// extracted by mini-css-extract-plugin
module.exports =  {"noResultsAlert":"pl__NoResultsAlert-module__noResultsAlert___NIUs8"};